"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@dnd-kit/core");
var _modifiers = require("@dnd-kit/modifiers");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DropRegions = require("./Components/DropRegions");
var _modifiers2 = require("./modifiers");
var _Sheet = _interopRequireDefault(require("./Components/Sheet"));
var _edSystem = require("@eduact/ed-system");
var _utils = require("@eduact/utils");
var _templateObject;
var _excluded = ["onChange", "children", "expanded", "header", "headerHeight", "onBackdropClick", "variant", "headerVariant", "relative"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var modifiers = [_modifiers.restrictToVerticalAxis, _modifiers2.rubberbandModifier];
var Region;
(function (Region) {
  Region["Collapse"] = "collapse";
  Region["Expand"] = "expand";
})(Region || (Region = {}));
var BottomSheet = function BottomSheet(_ref) {
  var onChange = _ref.onChange,
    children = _ref.children,
    expanded = _ref.expanded,
    header = _ref.header,
    _ref$headerHeight = _ref.headerHeight,
    headerHeight = _ref$headerHeight === void 0 ? '100px' : _ref$headerHeight,
    onBackdropClick = _ref.onBackdropClick,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'light' : _ref$variant,
    _ref$headerVariant = _ref.headerVariant,
    headerVariant = _ref$headerVariant === void 0 ? 'light' : _ref$headerVariant,
    _ref$relative = _ref.relative,
    relative = _ref$relative === void 0 ? false : _ref$relative,
    props = _objectWithoutProperties(_ref, _excluded);
  var tracked = (0, _react.useRef)({
    distance: 0,
    timestamp: 0,
    velocity: 0
  });
  var sensors = (0, _core.useSensors)((0, _core.useSensor)(_core.PointerSensor, {
    activationConstraint: {
      delay: 25,
      tolerance: 40
    }
  }));
  var handleDragEnd = function handleDragEnd(_ref2) {
    var over = _ref2.over;
    var velocity = tracked.current.velocity;
    if (Math.abs(velocity) > 500) {
      onChange(velocity > 0);
    } else if (over) {
      var _expanded = over.id === Region.Expand;
      onChange(_expanded);
    }
    tracked.current = {
      distance: 0,
      timestamp: 0,
      velocity: 0
    };
  };
  var bottomSheetRef = (0, _react.useRef)(null);
  (0, _utils.useOutsideAlert)(bottomSheetRef, function () {
    onBackdropClick === null || onBackdropClick === void 0 ? void 0 : onBackdropClick(true);
  });
  return /*#__PURE__*/_react["default"].createElement(_core.DndContext, {
    autoScroll: false,
    modifiers: modifiers,
    sensors: sensors,
    onDragMove: function onDragMove(_ref3) {
      var delta = _ref3.delta;
      var timestamp = Date.now();
      var timeDelta = timestamp - tracked.current.timestamp;
      var distance = tracked.current.distance - delta.y;
      var velocity = Math.round(distance / timeDelta * 1000);
      tracked.current = {
        distance: delta.y,
        velocity: velocity,
        timestamp: timestamp
      };
    },
    onDragEnd: handleDragEnd
  }, /*#__PURE__*/_react["default"].createElement(StyledDrawer, {
    relative: relative,
    variant: variant,
    ref: bottomSheetRef,
    headerHeight: headerHeight
  }, /*#__PURE__*/_react["default"].createElement(_Sheet["default"], _extends({
    variant: variant,
    headerVariant: headerVariant,
    expanded: expanded,
    header: header
  }, props), children), /*#__PURE__*/_react["default"].createElement(_DropRegions.DropRegions, null)));
};
var _default = BottomSheet;
exports["default"] = _default;
var StyledDrawer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t--header-height: ", ";\n\tposition: ", ";\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: flex-end;\n\tinset: 0;\n\tpointer-events: none;\n\toverflow: hidden;\n\t", "\n\t", "\n"])), function (_ref4) {
  var headerHeight = _ref4.headerHeight;
  return (0, _edSystem.getDynamicVariant)(headerHeight, 'sm');
}, function (props) {
  return props.relative ? 'absolute' : 'fixed';
}, function (_ref5) {
  var theme = _ref5.theme,
    headerHeight = _ref5.headerHeight,
    relative = _ref5.relative;
  return "".concat(theme.mediaQueries.medium, "{\n\t\t--header-height: ").concat((0, _edSystem.getDynamicVariant)(headerHeight, 'md'), ";\n\t}");
}, function (_ref6) {
  var theme = _ref6.theme,
    headerHeight = _ref6.headerHeight,
    relative = _ref6.relative;
  return "".concat(theme.mediaQueries.large, "{\n\t\t--header-height: ").concat((0, _edSystem.getDynamicVariant)(headerHeight, 'lg'), ";\n\t}");
});